import * as Icons from "@/assets/features/requistion";
import StatusBadge from "@/components/shared/badges/Badge";

const UserInfoCard = () => {
  return (
    <div className="bg-sidebar capitalize flex justify-between p-[2rem] gap-5 rounded-t-[1rem] mt-[1.5rem]">
      <div className="flex gap-4">
        <Icons.Account className="h-8 w-8" />
        <div>
          <p className="font-semibold text-md text-black space-y-2">
            kamal zakieldin
          </p>
          <p className="text-sm font-medium">Product manager</p>
          <p className="text-sm font-medium text-blue-300">
            kamalzakieldin@company.com
          </p>
        </div>
      </div>

      <div>
        <div className="flex items-center gap-2 text-xs text-secondary mb-6">
          <Icons.Clock className="w-3 h-3" color="var(--color-secondary)" />
          16 July 2024 . 08:38 pm
        </div>
        <StatusBadge status="pending" text="request modification" />
      </div>
    </div>
  );
};

export default UserInfoCard;
